export default __webpack_public_path__ + "static/media/voucher.a61294d3.svg";